import React, { useState, Fragment, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormComposer, Header, MultiLink } from "@egovernments/digit-ui-react-components";
import { newConfig as newConfigFI } from "../../../config/InspectionReportConfig";
import get from "lodash/get";
import orderBy from "lodash/orderBy";
import { Card } from "@material-ui/core";
import HouseIcon from "@mui/icons-material/House";
import ApplicationDetailsForm11 from "../../../../../templates/ApplicationDetails/form11";
import { NOCService } from "../../../../../../libraries/src/services/elements/NOC";
import { useLocation } from "react-router-dom";
const ApplicationDetail = () => {
  const { authority, state, plan, plinth, form, year, serial, formType, id: urlId } = useParams(); //:authority/:plan/:form/:year/:serial
  console.log(useParams(), "paramsHook");
  const location = useLocation();

  console.log(location, "locationCheck");
  const isFromDashboard = location?.pathname?.includes("dashboard-details");

  const idFromDashboard = Digit.SessionStorage.get("DASHBOARD_ID");
  const id = plinth
    ? `${authority}/${plinth}/${plan}/${form}/${year}/${serial}`
    : urlId
      ? urlId
      : state
        ? `${state}/${form}/${year}/${serial}`
        : isFromDashboard
          ? idFromDashboard
          : `${authority}/${plan}/${form}/${year}/${serial}`;
  console.log("loggingIdFromCompAyush", id, urlId, isFromDashboard, idFromDashboard);

  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [showToast, setShowToast] = useState(null);
  const [canSubmit, setSubmitValve] = useState(false);
  const [filters, setFilters] = useState(null);
  const defaultValues = {};
  const history = useHistory();
  // delete
  const [_formData, setFormData, _clear] = Digit.Hooks.useSessionStorage("store-data", null);
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_HAPPENED", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_SUCCESS_DATA", {});
  const [error, setError] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const { isLoading: bpaDocsLoading, data: bpaDocs } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"]);
  let { data: newConfig } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const { isMdmsLoading, data: mdmsData } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["RiskTypeComputation"]);
  const isEmployee = history.location.pathname.includes("employee");
  useEffect(() => {
    if (formType !== "NOC") {
      setFilters({
        applicationNo: id,
        isEmployee,
        formType,
      });
      return;
    }

    const fetchNocData = async () => {
      try {
        const response = await NOCService.NOCsearch({ tenantId: "up", filters: { applicationNo: id } });
        // Extract and build filters based on NOC response if needed
        console.log("responseFromNOCSearch", response);

        setFilters({
          applicationNo: response?.Noc?.[0]?.sourceRefId,
          isEmployee,
          formType: "FORM_MAP",
        });
      } catch (err) {
        console.error("Error in NOCsearch:", err);
      }
    };

    fetchNocData();
  }, [tenantId, id, isEmployee, formType]);
  const { data = {}, isLoading, refetch } = Digit.Hooks.obps.useBPADetailsPage(stateId, filters, {
    formType,
    config: {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      // refetchOnWindowFocus: true,
      // refetchOnReconnect: true,
    },
  });
  const { collectionBillRes, collectionBillDetails } = data;
  const appData = data?.LandUse?.[0] || data?.ownerRegistration?.[0] || data?.PurchasableFAR?.[0] || data?.BPA?.[0] || data?.applicationData;

  console.log("appDetail", data, appData);

  if (!isLoading && appData) {
    appData.paymentDetails = collectionBillRes?.[0]?.paymentDetails?.[0];
  }
  const [showOptions, setShowOptions] = useState(false);
  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate,
  } = Digit.Hooks.obps.useApplicationActions(stateId, formType);

  const nocMutation = Digit.Hooks.obps.useObpsAPI(tenantId, true);
  function checkHead(head) {
    if (head === "ES_NEW_APPLICATION_LOCATION_DETAILS") {
      return "TL_CHECK_ADDRESS";
    } else if (head === "ES_NEW_APPLICATION_OWNERSHIP_DETAILS") {
      return "TL_OWNERSHIP_DETAILS_HEADER";
    } else {
      return head;
    }
  }
  const closeToast = () => {
    setShowToast(null);
    setError(null);
  };
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
  }, []);
  const onFormValueChange = (setValue, formData, formState) => {
    setSubmitValve(!Object.keys(formState.errors).length);
  };
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  let configs = newConfig?.InspectionReportConfig ? newConfig?.InspectionReportConfig : newConfigFI;
  const nocApplicationId = appData?.nocList?.find((item) => item.businessService === userDetails?.organisationCode)?.applicationNo;
  console.log("userdetailsIndexFOrm", userDetails, nocApplicationId);

  const workFlowId = formType === "NOC" ? nocApplicationId : id;
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: workFlowId,
    moduleCode: appData?.businessService,
  });

  if (workflowDetails && workflowDetails.data && !workflowDetails.isLoading) {
    workflowDetails.data.initialActionState = workflowDetails?.data?.initialActionState || { ...workflowDetails?.data?.actionState } || {};
    workflowDetails.data.actionState = { ...workflowDetails.data };
  }
  const userInfo = Digit.UserService.getUser();
  if (workflowDetails?.data?.processInstances?.length > 0) {
    let filteredActions = [];
    filteredActions = get(workflowDetails?.data?.processInstances[0], "nextActions", [])?.filter((item) => item.action != "ADHOC");
    let actions = orderBy(filteredActions, ["action"], ["desc"]);
    if ((!actions || actions?.length == 0) && workflowDetails?.data?.actionState) workflowDetails.data.actionState.nextActions = [];
  }
  if (workflowDetails?.data?.nextActions?.length > 0) {
    workflowDetails.data.nextActions = workflowDetails?.data?.nextActions?.filter((actn) => actn.action !== "INITIATE");
    workflowDetails.data.nextActions = workflowDetails?.data?.nextActions?.filter((actn) => actn.action !== "ADHOC");
  }

  let dowloadOptions = [];

  if (workflowDetails?.data?.nextActions?.length > 0) {
    workflowDetails.data.nextActions = workflowDetails?.data?.nextActions?.filter((actn) => actn.action !== "SKIP_PAYMENT" && actn.action !== "EDIT");
  }
  const handleModal = () => {
    history.push({
      pathname: `/digit-ui/employee`,
    });
  };

  return (
    <Fragment>
      <div className={"employee-main-application-details"}>
        {!isLoading && appData && (
          <React.Fragment>
            {/* <Card style={{ margin: "15px 0px 15px", padding: "8px", position: "relative", marginRight: "30px" }} className={"employeeCard-override"}>
              <HouseIcon style={{ color: "red" }} onClick={handleModal} /> Take Action
            </Card> */}
            <ApplicationDetailsForm11
              applicationDetails={appData}
              isLoading={updatingApplication}
              isDataLoading={updatingApplication}
              applicationData={appData}
              refetch={refetch}
              nocMutation={nocMutation}
              mutate={mutate}
              workflowDetails={workflowDetails}
              businessService={
                workflowDetails?.data?.applicationBusinessService ? workflowDetails?.data?.applicationBusinessService : appData?.businessService
              }
              moduleCode={appData?.businessService}
              showToast={showToast}
              ActionBarStyle={isMobile ? {} : { paddingRight: "50px" }}
              MenuStyle={isMobile ? {} : { right: "50px" }}
              setShowToast={setShowToast}
              closeToast={closeToast}
              statusAttribute={"state"}
              timelineStatusPrefix={`WF_${workflowDetails?.data?.applicationBusinessService ? workflowDetails?.data?.applicationBusinessService : appData?.businessService
                }_`}
              isFromDashboard={isFromDashboard}
            />
          </React.Fragment>
        )}
      </div>
    </Fragment>
  );
};

export default ApplicationDetail;
